<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-01 03:17:21
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-12 21:11:44
 * @Description: file content
 -->
<template>
  <div class="loading">
    <div class="scrim">
      <div class="common-load">
        <img src="https://assets.wxmp.ruthus.com/henduoke/loading2.gif" alt />
        <span class="t1">{{t1}}</span>
        <span class="t2">{{t2}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      t1: "",
      t2: ""
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {
    if (
      location.host.indexOf(".huafacrm.com") > -1 ||
      location.host.indexOf(".huafamarkting.com") > -1
    ) {
      this.t1 = "华发股份";
      this.t2 = "与城市共创美好";
    } else if (this.global.SUBDOMAIN == "henduoke") {
      this.t1 = "很多客";
      this.t2 = "让好品牌轻松找到很多客";
    } else if (this.global.SUBDOMAIN == "henduobao") {
      this.t1 = "很多宝";
      this.t2 = "为你精选高净值精彩内容";
    } else if (this.global.SUBDOMAIN == "zhzy") {
      this.t1 = "正宏E家";
      this.t2 = "美好即将开始";
    } else {
      this.t1 = "AI智慧营销";
      this.t2 = "美好即将开始";
    }
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.scrim {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 100;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}
.common-load {
  background: rgba(0, 0, 0, 0.7);
  border-radius: 5px;
  text-align: center;
  margin-top: -100px;
}
.common-load img {
  display: block;
  width: 200px;
  height: 200px;
  margin-top: -40px;
}
.common-load span {
  display: block;
  color: #fff;
  font-size: 14px;
}
.common-load .t1 {
  font-size: 14px;
  margin-top: -40px;
}
.common-load .t2 {
  margin: 15px 0;
}
</style>